export enum UsersViewType {
  Residents = 'residents',
  Staff = 'staff',
  Flagged = 'flagged',
}
